// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBlPzO-Z9DKVlJsdCLFSAjUwpsoiXzq3v8",
    authDomain: "mycheftool-d3899.firebaseapp.com",
    databaseURL: "https://mycheftool-d3899.firebaseio.com",
    projectId: "mycheftool-d3899",
    storageBucket: "mycheftool-d3899.appspot.com",
    messagingSenderId: "934198322702"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
